export function initFilterSolutions() {
    const filterCheckboxes = document.querySelectorAll('.js-filterSolutions');
    const searchInput = document.querySelector('input[name="input_search_solutions"]');
    const searchForm = document.querySelector('.js-searchSolutions');
    const items = document.querySelectorAll('.dcSolutionsList__item');
    const accordions = document.querySelectorAll('.js-filterAccordion');
    const activeFiltersContainer = document.querySelector('.js-activeFilters');
    const paginationContainer = document.querySelector('.js-pagination');

    const wrapper = document.querySelector('.dcSolutionsListWrapper');
    if (!items.length || !wrapper) return;

    const itemsPerPage = parseInt(wrapper.getAttribute('data-items-per-page')) || 12;
    let currentPage = 1;

    const attachPaginationEvents = () => {
        if (!paginationContainer) return;

        paginationContainer.querySelectorAll('.pagination__item').forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                if (item.classList.contains('is-disabled') || item.classList.contains('pagination__item--active')) return;

                if (item.classList.contains('pagination__prev')) {
                    currentPage--;
                } else if (item.classList.contains('pagination__next')) {
                    currentPage++;
                } else {
                    currentPage = parseInt(item.textContent);
                }

                updateFilters(true, true);
                const filterList = document.querySelector('.dcCollectionFilterList');
                if (filterList) {
                    window.scrollTo({ top: filterList.offsetTop - 100, behavior: 'smooth' });
                }
            });
        });
    };

    // Load state from URL
    const loadStateFromUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        
        // Load Search
        const searchParam = urlParams.get('q');
        if (searchParam && searchInput) {
            searchInput.value = searchParam;
        }

        // Load Filters
        filterCheckboxes.forEach(checkbox => {
            const name = checkbox.getAttribute('name');
            const urlValues = urlParams.getAll(name);
            if (urlValues.includes(checkbox.value)) {
                checkbox.checked = true;
            }
        });

        // Load Page
        const pageParam = urlParams.get('page_solutions');
        if (pageParam) {
            currentPage = parseInt(pageParam) || 1;
        }
    };

    // Update URL with current state
    const updateUrl = (activeFilters, searchTerm) => {
        const urlParams = new URLSearchParams();

        if (searchTerm) {
            urlParams.set('q', searchTerm);
        }

        filterCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                urlParams.append(checkbox.name, checkbox.value);
            }
        });

        if (currentPage > 1) {
            urlParams.set('page_solutions', currentPage);
        }

        const newUrl = `${window.location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    };

    // Accordion Toggle Logic
    accordions.forEach(accordion => {
        const toggle = accordion.querySelector('.js-filterToggle');
        toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = accordion.classList.contains('is-open');
            
            // Close all others
            accordions.forEach(acc => acc.classList.remove('is-open'));
            
            if (!isOpen) {
                accordion.classList.add('is-open');
            }
        });
    });

    // Close accordions on click outside
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.js-filterAccordion')) {
            accordions.forEach(acc => acc.classList.remove('is-open'));
        }
    });

    const renderActiveFilters = () => {
        if (!activeFiltersContainer) return;

        activeFiltersContainer.innerHTML = '';
        const activeFilters = Array.from(filterCheckboxes).filter(cb => cb.checked);

        if (activeFilters.length > 0) {
            activeFilters.forEach(checkbox => {
                const label = checkbox.closest('.specialcheckbox').querySelector('.specialcheckbox__label').textContent;
                const tag = document.createElement('div');
                tag.className = 'dcActiveFilters__tag js-removeFilter';
                tag.setAttribute('data-name', checkbox.name);
                tag.setAttribute('data-value', checkbox.value);
                tag.innerHTML = `
                    <span>${label}</span>
                    <i class="icon icon-close"></i>
                `;
                activeFiltersContainer.appendChild(tag);
            });

            const clearAllBtn = document.createElement('button');
            clearAllBtn.className = 'dcActiveFilters__clear js-clearAllFilters';
            clearAllBtn.textContent = 'Alle Filter löschen';
            activeFiltersContainer.appendChild(clearAllBtn);
        }
    };

    const renderPagination = (visibleCount) => {
        if (!paginationContainer) return;

        const totalPages = Math.ceil(visibleCount / itemsPerPage);
        paginationContainer.innerHTML = '';

        if (totalPages <= 1) return;

        const ul = document.createElement('ul');
        ul.className = 'pagination';

        // Prev Button
        const liPrev = document.createElement('li');
        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = `btnNoStyle pagination__item pagination__prev ${currentPage === 1 ? 'is-disabled' : ''}`;
        prevBtn.innerHTML = '<i class="icon icon-arrow-left"></i>';
        liPrev.appendChild(prevBtn);
        ul.appendChild(liPrev);

        // Page Buttons
        for (let i = 1; i <= totalPages; i++) {
            const li = document.createElement('li');
            const pageBtn = document.createElement('button');
            pageBtn.type = 'button';
            pageBtn.className = `btnNoStyle pagination__item ${currentPage === i ? 'pagination__item--active' : ''}`;
            pageBtn.textContent = i;
            li.appendChild(pageBtn);
            ul.appendChild(li);
        }

        // Next Button
        const liNext = document.createElement('li');
        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = `btnNoStyle pagination__item pagination__next ${currentPage === totalPages ? 'is-disabled' : ''}`;
        nextBtn.innerHTML = '<i class="icon icon-arrow-right"></i>';
        liNext.appendChild(nextBtn);
        ul.appendChild(liNext);

        paginationContainer.appendChild(ul);

        attachPaginationEvents();
    };

    const updateFilters = (shouldUpdateUrl = true, isPageChange = false) => {
        const activeFilters = {};
        
        if (!isPageChange) {
            currentPage = 1;
        }

        // Reset all items' visibility first
        items.forEach(item => {
            item.style.display = 'none';
        });

        // Update selection counters per accordion
        accordions.forEach(accordion => {
            const checkedInCategory = accordion.querySelectorAll('.js-filterSolutions:checked').length;
            const counterEl = accordion.querySelector('.js-filterCounter');
            if (counterEl) {
                counterEl.textContent = checkedInCategory > 0 ? `${checkedInCategory}` : '';
                counterEl.style.display = checkedInCategory > 0 ? 'inline' : 'none';
            }
        });

        filterCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                const name = checkbox.getAttribute('name').replace('filter_solutions_', '');
                if (!activeFilters[name]) {
                    activeFilters[name] = [];
                }
                activeFilters[name].push(checkbox.value);
            }
        });

        const searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
        const visibleItems = [];

        items.forEach(item => {
            let isVisible = true;

            // 1. Check Filters (OR within category, AND between categories)
            for (const [category, selectedValues] of Object.entries(activeFilters)) {
                const itemValuesRaw = item.getAttribute(`data-filter-${category}`);
                if (!itemValuesRaw) {
                    isVisible = false;
                    break;
                }

                const itemValues = itemValuesRaw.toLowerCase().split(';').map(v => v.trim());
                const hasMatch = selectedValues.some(val => itemValues.includes(val.toLowerCase().trim()));
                
                if (!hasMatch) {
                    isVisible = false;
                    break;
                }
            }

            // 2. Check Search
            if (isVisible && searchTerm !== '') {
                const headline = item.querySelector('.dcSolutionCard__headline')?.textContent.toLowerCase() || '';
                const summary = item.querySelector('.dcSolutionCard__summary')?.textContent.toLowerCase() || '';
                const manufacturer = item.querySelector('.dcSolutionCard__manufacturer')?.textContent.toLowerCase() || '';
                const tags = Array.from(item.querySelectorAll('.dcTag')).map(tag => tag.textContent.toLowerCase()).join(' ');

                const matchesSearch = headline.includes(searchTerm) || 
                                     summary.includes(searchTerm) || 
                                     manufacturer.includes(searchTerm) ||
                                     tags.includes(searchTerm);
                
                if (!matchesSearch) {
                    isVisible = false;
                }
            }

            if (isVisible) {
                visibleItems.push(item);
            }
        });

        const visibleCount = visibleItems.length;

        // Pagination Logic
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;

        visibleItems.forEach((item, index) => {
            if (index >= start && index < end) {
                item.style.display = '';
            } else {
                item.style.display = 'none';
            }
        });

        renderActiveFilters();
        renderPagination(visibleCount);

        if (shouldUpdateUrl) {
            updateUrl(activeFilters, searchTerm);
        }
    };

    // Initial load
    loadStateFromUrl();
    attachPaginationEvents();
    updateFilters(false, true); // Update UI without pushing to URL on first load, treat as page change to preserve page from URL

    filterCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => updateFilters());
    });

    if (searchInput) {
        searchInput.addEventListener('input', () => updateFilters());
    }

    if (searchForm) {
        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            updateFilters();
        });
    }

    // Event Delegation for Tags
    if (activeFiltersContainer) {
        activeFiltersContainer.addEventListener('click', (e) => {
            const removeBtn = e.target.closest('.js-removeFilter');
            if (removeBtn) {
                const name = removeBtn.getAttribute('data-name');
                const value = removeBtn.getAttribute('data-value');
                const checkbox = document.querySelector(`input[name="${name}"][value="${value}"]`);
                if (checkbox) {
                    checkbox.checked = false;
                    updateFilters();
                }
            }

            if (e.target.classList.contains('js-clearAllFilters')) {
                filterCheckboxes.forEach(cb => cb.checked = false);
                updateFilters();
            }
        });
    }
}
